module.exports = __webpack_public_path__ + "img/welcome2.c022e624.png";